module.exports = __webpack_public_path__ + "h5/img/product.7bf31a37.jpg";